import barBasicPreset from './preset-bar-basic';
import barHorizontalBasicPreset from './preset-bar-horizontal-basic';
import barHorizontalStackedPreset from './preset-bar-horizontal-stacked';
import barStackedPreset from './preset-bar-stacked';
import lineBasicPreset from './preset-line-basic';
import pieBasicPreset from './preset-pie-basic';
import pieDoughnutPreset from './preset-pie-doughnut';
import type { ChartPreset } from './type';

const chartPresets: ChartPreset[] = [
    barBasicPreset,
    barStackedPreset,
    barHorizontalBasicPreset,
    barHorizontalStackedPreset,
    lineBasicPreset,
    pieBasicPreset,
    pieDoughnutPreset,
];

export const colorPresets: { key: string; name: string; colors: string[] }[] = [
    {
        key: '蓝黄shine',
        name: '蓝黄shine',
        colors: ['#387dfdff', '#0dcbbbff', '#ffc100ff', '#ff8545ff', '#06b2f2ff'],
    },
    {
        key: '莫兰迪shine',
        name: '莫兰迪shine',
        colors: ['#cbd3efff', '#efc8c2ff', '#f6debeff', '#cde7c7ff', '#d1c2efff'],
    },
    {
        key: '紫色shine',
        name: '紫色shine',
        colors: ['#eabef3ff', '#9677e4ff', '#3e659dff', '#1f4749ff', '#142412ff'],
    },
    {
        key: '黑黄shine',
        name: '黑黄shine',
        colors: ['#202020ff', '#6f6f6fff', '#959595ff', '#ffd100ff', '#c6c6c6ff'],
    },
    {
        key: '粉蓝shine',
        name: '粉蓝shine',
        colors: ['#70daaeff', '#86d9fbff', '#feb5e7ff', '#feda61ff', '#b4c9ffff'],
    },
];

export const defaultPresetColors = colorPresets[0].colors;

export default chartPresets;
